import { Link } from "react-router-dom";

const solutionsMenu = [
  { label: "Network Detection And Response (NDR)", link: "/solutions/ndr" },
  { label: "Database Security", link: "/solutions/database-security" },
  { label: "Multi-Cloud Security & Multi-Factor Auth", link: "/solutions/multi-cloud-security" },
  { label: "Software Solutions", link: "/solutions/software-solution" },
  { label: "Cyber Essentials", link: "/solutions/cyber-essential" },
  { label: "ISO Accreditation", link: "/solutions/iso-accreditation" },
  { label: "Comms Infrastructure", link: "/solutions/comms-infrastructure" },
  { label: "VoIP and Hosted Voice", link: "/solutions/voip-and-hosted-voice" },
  { label: "Connectivity", link: "/solutions/connectivity" },
  { label: "Business Mobile", link: "/solutions/business-mobile" },
  { label: "Combine and Save", link: "/solutions/combine-and-save" },
];

export const menuItems = [
  {
    key: "home",
    label: <Link to="/">Home</Link>,
  },
  {
    key: "solutions",
    label: "Solutions",
    children: solutionsMenu.map((item, index) => ({
      key: `solution-${index}`,
      label: <Link to={item.link}>{item.label}</Link>,
    })),
  },
  {
    key: "about",
    label: <Link to="/about">About</Link>,
  },
  {
    key: "contact",
    label: <Link to="/contact">Contact</Link>,
  },
];
